import { bridge, BridgeChannels, BridgeActions } from '../bridge';

/**
 * Copy text to clipboard.
 * Uses native bridge when running in the app, falls back to navigator.clipboard for web.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (bridge.isNative) {
    try {
      await bridge.request(BridgeChannels.CLIPBOARD, BridgeActions.COPY, { text });
      return true;
    } catch (e) {
      console.error('[Clipboard] Native copy failed:', e);
      return false;
    }
  }

  // Fallback to browser clipboard API
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    console.error('[Clipboard] Browser copy failed:', e);
    return false;
  }
}
